export class TotalVOBandVolyDetails{
    date:Date;
    vob:number;
    voly:number;
}